<template>
  <a-form-model
    style='width: 800px'
    :model='ruleForm'
    :rules='rules'
    ref='form'
    :label-col='{span:4}' :wrapper-col='{span:20}'>
    <a-form-model-item label='商品标题前缀' prop='prefix'>
      <a-input v-model='ruleForm.prefix' placeholder='请输入' :maxLength='10' allowClear style='width: 400px'/>
    </a-form-model-item>
    <a-form-model-item label='接口域名' prop='domain'>
      <a-input v-model='ruleForm.domain' placeholder='请输入' allowClear style='width: 400px'/>
    </a-form-model-item>
    <a-form-model-item label='APPID' prop='appId'>
      <a-input v-model='ruleForm.appId' placeholder='请输入' allowClear style='width: 400px'/>
    </a-form-model-item>

    <a-form-model-item label='平台公钥' prop='publicKey'>
      <a-input v-model='ruleForm.publicKey' placeholder='请输入' allowClear style='width: 400px'/>
    </a-form-model-item>

    <a-form-model-item
      :wrapper-col='{ span: 14, offset: 4 }'>
      <span>
        <a-button type='primary' @click='onSubmitEvent' :loading='submitLoading'>{{ submitButtonName }}</a-button>
        <!--        <span v-if='showTips' style='margin-left: 20px'>*当前版本最多添加3个账号</span>-->
      </span>
    </a-form-model-item>
  </a-form-model>
</template>

<script>
export default {
  name: 'AccountEditorView',
  components: {},
  props: {
    submitLoading: {
      type: Boolean,
      default: false
    },
    showTips: {
      type: Boolean,
      default: true
    },
    value: {
      type: Object,
      default: () => new Object()
    },
    submitButtonName: {
      type: String,
      default: '提交申请'
    }
  },
  data() {
    return {
      ruleForm: {
        publicKey: '',
        appId: '',
        domain: '',
        prefix: ''
      },
      rules: {
        prefix: [
          { required: true, message: '请输入商品前缀', trigger: ['blur', 'change'] },
          { validator: this.validatorPrefix, trigger: ['blur', 'change'] }
        ],
        domain: [
          { required: true, message: '请输入接口域名', trigger: ['blur', 'change'] }
        ],
        appId: [
          { required: true, message: '请输入appId', trigger: ['blur', 'change'] }
        ],
        publicKey: [
          { required: true, message: '请输入平台公钥', trigger: ['blur', 'change'] }
        ]
      }
    }
  },
  mounted() {
    this.ruleForm = { ...this.value }
  },
  methods: {
    validatorPrefix(rule, value, callback) {
      if (value && value.length > 10) {
        callback(new Error('长度只能在10个字之内'))
      } else {
        callback()
      }
    },
    onSubmitEvent() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.$emit('submit', { ...this.ruleForm })
        } else {
          this.$message.error('请完善账号信息')
        }
      })
    }
  }
}
</script>

<style scoped lang='less'>

</style>
